import { useTranslation } from "react-i18next"
import { Dispatch, useEffect, useState } from "react"

import "./policyDialog.scss"
import Dialog from "@/components/dialog/Dialog"
import BasicButton from "@/components/button/BasicButton"
import { marked } from "marked"
import dompurify from "dompurify"

export default function PolicyDialog({
  policy,
  onClickAgree,
  nameTeam,
  open,
  onClose,
}: {
  policy: string
  onClickAgree: () => void
  nameTeam?: string
  open: boolean
  onClose: () => void
}) {
  const { t } = useTranslation("")
  const [transformContent, setTransformContent] = useState<string>("")
  const sanitize = dompurify.sanitize

  const handleClickAgree = () => {
    onClickAgree()
    onClose()
  }

  const transform = marked.setOptions({
    renderer: new marked.Renderer(),
    gfm: true,
    breaks: true,
    pedantic: false,
  })

  useEffect(() => {
    if (policy.length > 0) {
      const transformContent = async () => {
        let content = await transform(policy)
        const regex = new RegExp("\\${" + nameTeam + "}", "g")
        content = content.replace(regex, nameTeam || "")
        setTransformContent(content)
      }

      transformContent()
    }
  }, [policy, nameTeam])

  return (
    <Dialog
      className="LeaveCoachDialogCont"
      title={t("confirm")}
      open={open}
      onClose={onClose}
      maxHeight="100vh"
      footer={
        <>
          <BasicButton type="default-outlined" size="md" onClick={onClose}>
            {t("button.cancel")}
          </BasicButton>
          <BasicButton type="primary-contained" size="md" onClick={handleClickAgree}>
            {t("button.agree")}
          </BasicButton>
        </>
      }>
      <div
        className="termsContentMarkdown"
        dangerouslySetInnerHTML={{ __html: sanitize(transformContent) }}
      />
    </Dialog>
  )
}
